@import './primitives.css';

@tailwind base;
@tailwind components;
@tailwind utilities;

/**
 * ember-primitives sets color-scheme on the root element.
 *
 * light-dark() follows it, also inside the Shadow DOM of the output.
 */
:root {
  --limber-surface: light-dark(white, #1c1e26);
  --limber-surface-hover: light-dark(#f3f4f6, #2e303e);
  --limber-text: light-dark(black, #e5e7eb);
  --limber-border: light-dark(#e5e7eb, #44465a);
}

/**
 * The prose-invert class needs a template that knows the color scheme.
 *
 * Many templates use .prose, so the variables switch here instead.
 */
.prose {
  --tw-prose-body: light-dark(#374151, var(--tw-prose-invert-body));
  --tw-prose-headings: light-dark(#111827, var(--tw-prose-invert-headings));
  --tw-prose-lead: light-dark(#4b5563, var(--tw-prose-invert-lead));
  --tw-prose-links: light-dark(#111827, var(--tw-prose-invert-links));
  --tw-prose-bold: light-dark(#111827, var(--tw-prose-invert-bold));
  --tw-prose-counters: light-dark(#6b7280, var(--tw-prose-invert-counters));
  --tw-prose-bullets: light-dark(#d1d5db, var(--tw-prose-invert-bullets));
  --tw-prose-hr: light-dark(#e5e7eb, var(--tw-prose-invert-hr));
  --tw-prose-quotes: light-dark(#111827, var(--tw-prose-invert-quotes));
  --tw-prose-quote-borders: light-dark(#e5e7eb, var(--tw-prose-invert-quote-borders));
  --tw-prose-captions: light-dark(#6b7280, var(--tw-prose-invert-captions));
  --tw-prose-kbd: light-dark(#111827, var(--tw-prose-invert-kbd));
  --tw-prose-code: light-dark(#111827, var(--tw-prose-invert-code));
  --tw-prose-th-borders: light-dark(#d1d5db, var(--tw-prose-invert-th-borders));
  --tw-prose-td-borders: light-dark(#e5e7eb, var(--tw-prose-invert-td-borders));
}


* {
  touch-action: manipulation;
}

/*
* From
*   https://fonts.googleapis.com/css2?family=Source+Code+Pro&display=swap
*/
@font-face {
  font-family: 'Source Code Pro';
  font-style: normal;
  font-weight: 400;
  font-display: swap;
  src: url(https://fonts.gstatic.com/s/sourcecodepro/v30/HI_diYsKILxRpg3hIP6sJ7fM7PqPMcMnZFqUwX28DMyQtMlrTA.woff2) format('woff2');
  unicode-range: U+0000-00FF, U+0131, U+0152-0153, U+02BB-02BC, U+02C6, U+02DA, U+02DC, U+0304, U+0308, U+0329, U+2000-206F, U+20AC, U+2122, U+2191, U+2193, U+2212, U+2215, U+FEFF, U+FFFD;
}


.loader {
  border: 4px solid var(--ember-faint-gray);
  border-radius: 50%;
  border-top: 4px solid var(--code-keyword);
}

.copy-menus-hidden [data-test-copy-menu] {
  display: none;
}

.glimdown-render {
  margin-top: 0.5rem;
}

[data-repl-output] button {
  border-radius: 0.25rem;
  padding: 0.25rem 0.5rem;
  border: 1px solid var(--horizon-border);
}

.gutter {
  background: var(--code-keyword);
}
.gutter-horizontal {
  cursor: col-resize;
}
.gutter-vertical {
  cursor: row-resize;
}

dialog::backdrop {
  backdrop-filter: blur(1px);
}

.menu__keyboard__help {
  font-size: 0.65rem;
  padding: 0.1rem 0.6rem 0.3rem 1rem;
  background: var(--limber-surface);
  color: var(--limber-text);
  z-index: -1;
  border-bottom-left-radius: 0.25rem;
  border-bottom-right-radius: 0.25rem;
}

@media (pointer:coarse) {
  .menu__keyboard__help {
    display: none;
  }
}

pre.shiki {
  padding: 1rem;
  border-radius: 0.5rem;
  box-shadow: inset 0px 1px 1px 1px black;
}

.limber__editor-placeholder pre,
.limber__editor-placeholder pre.shiki {
  box-shadow: none;
}


